import lang from "./lang.en";

export default {
	"common-enums": {
		...lang,
	},
};
